// ==================================================================================
// Digital Approval System (DAS) - Workflow Template Endpoints
// ==================================================================================
// URL builders for workflow template API endpoints
// ==================================================================================

import { buildEndpoint, buildEndpointWithQuery } from '../base.endpoints';
import type { ID } from '../../types/common.types';
import type { WorkflowTemplateQueryParameters } from '../../types/das/workflowTemplates.types';

const BASE_PATH = 'das/workflow-templates';

/**
 * Workflow Template API Endpoints
 */
export const workflowTemplateEndpoints = {
  /**
   * Get all workflow templates
   */
  getAll: (params?: WorkflowTemplateQueryParameters) =>
    params && Object.keys(params).length > 0
      ? buildEndpointWithQuery(BASE_PATH, params)
      : buildEndpoint(BASE_PATH),

  /**
   * Get workflow template by ID
   */
  getById: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /**
   * Get active workflow templates only
   */
  getActive: () => buildEndpoint(`${BASE_PATH}/active`),

  /**
   * Get workflow templates by category
   */
  getByCategory: (category: string) => buildEndpoint(`${BASE_PATH}/category/${category}`),

  /**
   * Get workflow templates by request type
   */
  getByRequestType: (requestTypeCode: string) =>
    buildEndpoint(`${BASE_PATH}/request-type/${requestTypeCode}`),

  /**
   * Create new workflow template
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update workflow template
   */
  update: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /**
   * Delete workflow template
   */
  delete: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),
};
